// Pwa
import { GoogleAnalyticsService } from '@grupoboticario/barril-del-chavo'
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime'

const genericPwaEvent = {
  event: 'ga-event',
  'event-category': 'pwa',
}

const pwaEvents = {
  onUpdateReady: {
    ...genericPwaEvent,
    'event-label': 'atualizacão-disponivel',
  },
  onUpdated: {
    ...genericPwaEvent,
    'event-label': 'atualizado',
  },
  onUpdating: {
    ...genericPwaEvent,
    'event-label': 'comecou-atualizacao',
  },
  onUpdateFailed: {
    ...genericPwaEvent,
    'event-label': 'falhou-atualizacao',
  },
  onInstalled: {
    ...genericPwaEvent,
    'event-label': 'atualizacao-com-sucesso',
  },
}

const pwaRoutines = {
  onUpdateReady: () => {
    // tem um update disponivel
    GoogleAnalyticsService.event(pwaEvents.onUpdateReady)
    OfflinePluginRuntime.applyUpdate()
  },
  onUpdated: () => {
    // Atualizou
    GoogleAnalyticsService.event(pwaEvents.onUpdated)
    return window.location.reload()
  },

  onUpdating: () => {
    // Comecou a atualização
    GoogleAnalyticsService.event(pwaEvents.onUpdating)
  },
  onUpdateFailed: () => {
    // Falhou a atualizacão
    // Aqui quando falhar mandar o stack trace e ver o que rolou
    GoogleAnalyticsService.event(pwaEvents.onUpdateFailed)
  },
  onInstalled: () => {
    // Instalou e deu tudo certo
    GoogleAnalyticsService.event(pwaEvents.onInstalled)
  },
}

export default pwaRoutines
